import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const LoginService = (payload: LoginType) => {
  return HTTP_CLIENT.post(Endpoint.auth.login, payload);
};

const ForgotPasswordService = (payload: ForgotPasswordType) => {
  return HTTP_CLIENT.post(Endpoint.auth.forgotPassword, payload);
};

interface ResetPasswordServiceProps {
  password: string;
  token: string;
}

const ResetPasswordService = (payload: ResetPasswordServiceProps) => {
  return HTTP_CLIENT.post(
    Endpoint.auth.resetPassword,
    {
      password: payload.password,
    },
    {
      headers: {
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

const LogoutService = () => {
  return HTTP_CLIENT.post(Endpoint.auth.logout);
};

export {
  LoginService,
  ForgotPasswordService,
  ResetPasswordService,
  LogoutService,
};
